import {getSelectedPudoAddress} from '../../PudoSelectors';
import {
  getDeliveryType, getSelectedResidentialAddress, getSettings,
} from '../../selectors';

export default (state) => {
  if (getSettings(state)?.validate_ie_address_for_amazonpay) {
    if (getDeliveryType(state) === 'pudo') {
      try {
        const selectedCollectionPoint = getSelectedPudoAddress(state);
        if (selectedCollectionPoint) {
          const countryCode = selectedCollectionPoint?.countryCode;
          const postCode = selectedCollectionPoint?.postcode;
          return countryCode?.toLowerCase() === 'ie' && (!postCode?.length || postCode?.length < 4);
        }
      } catch {
        // Return false as no selected pudo address yet, therefore not invalid
        return false;
      }
    }
    
    try {
      const selectedResidentialAddress = getSelectedResidentialAddress(state);
      if (selectedResidentialAddress) {
        const countryCode = selectedResidentialAddress?.country;
        const postCode = selectedResidentialAddress?.postCode;
        return countryCode?.toLowerCase() === 'ie' && (!postCode?.length || postCode?.length < 4);
      }
    } catch {
      // Return false as no selected pudo address yet, therefore not invalid
      return false;
    }
    
    return false;
  }
  
  return false;
};
